import { useMemo } from 'react';
import { useAuth } from '../contexts/AuthContext';

function hasSuperAdminRole(user: {
  role?: string;
  staffRole?: string;
  staffRoles?: string[];
}): boolean {
  const candidates = [
    user.role,
    user.staffRole,
    ...(Array.isArray(user.staffRoles) ? user.staffRoles : []),
  ];
  return candidates.some((r) => r === 'SuperAdmin' || r === 'God');
}

/** Platform admin (Admin collection) with SuperAdmin or God — can manage staff create & permission matrix. */
export function useIsPharmacySuperAdmin(): boolean {
  const { user } = useAuth();
  return useMemo(() => {
    if (!user) return false;
    return hasSuperAdminRole(user);
  }, [user]);
}
